import { Injectable } from '@angular/core';
import { ToastrService } from '@services/toaster.service';
import { MatDialog } from '@angular/material/dialog';
import { LocalStorageService } from '@services/local-storage.service';
import { HostnameService } from '@services/hostname.service';
import { GlobalDataService } from '@services/global-data.service';
import { MakersiteService } from '@services/makersite.service';
import { Router } from '@angular/router';
import { ConfirmationDialogComponent } from '@dialogs/confirmation-dialog/confirmation-dialog.component';
import { InviteShareComponent } from '@dialogs/share-invite/share-invite-dialog.component';
import { ProductSearchDialogComponent } from '@dialogs/product-search-dialog/product-search-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ComposerService {
  constructor(
    private toastrService: ToastrService,
    private dialog: MatDialog,
    private router: Router,
    private localStorageService: LocalStorageService,
    private hostnameService: HostnameService,
    private makersiteService: MakersiteService,
    private globalDataService: GlobalDataService
  ) {
  }

  hasUnsavedChanges = false;

  resumeImport(resumeBomImport) {
    this.globalDataService.setResumeImport(resumeBomImport);
    this.router.navigate(['/composer', 'importer', 'bom_import']);
  }

  getEnrichProduct(rid) {
    const data = {
      multiple: true,
      selectOption: false,
      type: 'enrich-search',
      action: 'enrich-product-search',
      rid
    };
    const dialogRef = this.dialog.open(ProductSearchDialogComponent, {
      data,
      panelClass: 'standard-dialog'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.makersiteService.enrichProduct(rid, result).subscribe((res: any) => {
          this.toastrService.show(res ? res.message : 'Something went wrong', 3000);
        });
      }
    });
  }

  openMattermap(rid) {
    this.globalDataService.setSelectedApp(undefined);
    this.globalDataService.setPpmSelectedItem(undefined);
    this.router.navigate(['mattermaps/overview/', rid]);
  }

  dataOperation(action: 'duplicate'|'copy'|'merge'|'deploy'|'fork', rid) {
    if (action === 'duplicate') action = 'copy';
    this.makersiteService.dataSetOprations(action, rid).subscribe((res: any) => {
      this.toastrService.show('Success', 1000);
      let { rid } = res;
      rid = rid.replace('#', '');
      this.router.navigate(['/composer/metadata/', rid]);
    });
  }
  pull(rid) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        header: 'Publish to Makersite',
        text: null,
        cancel_text: 'Cancel',
        publish_text: 'Publish',
        type: 'Addpullrequest',
      },
      panelClass: 'pullrequest-container',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const obj = {
          key: rid,
          comment: result,
        };
        if (rid && obj.comment !== undefined) {
          this.makersiteService.dataSetOprations('pull', rid, obj).subscribe((res: any) => {
            this.toastrService.show(res.message, 2000);
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
              this.router.navigate(['/composer/metadata/', rid]);
            });
          });
        }
      }
    });
  }

  openInMcda(rid) {
    this.router.navigate(['mcda', rid]);
  }

  reCalculate(selectedTabName, rid) {
    const tab = selectedTabName;
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        header: `Re-calculate ${tab}`,
        text: `Re-calculating will replace all existing ${tab}. Are you sure?`,
        cancel_text: 'No',
        delete_text: 'Yes',
      },
    });

    dialogRef.afterClosed().subscribe((confirm) => {
      if (!confirm) return;
      if (tab === 'Environmental Impacts') {
        this.makersiteService.reCalculateEI(rid).subscribe((res: any) => {
          this.toastrService.show(res.message);
          // this.reloadData();
        });
      } else if (tab === 'Exemptions') {
        this.makersiteService.reCalculateExemptions(rid).subscribe((res: any) => {
          this.toastrService.show(res.message);
          // this.reloadData();
        });
      }
    });
  }

  deleteData(productName, rid) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        header: 'Delete Item?',
        text: `Would you like to delete the ${productName} dataset?`,
        cancel_text: 'Cancel',
        delete_text: 'Delete',
      },
    });

    dialogRef.afterClosed().subscribe((confirm) => {
      if (!confirm) return;
      this.makersiteService.deleteData(rid).subscribe((res) => {
        const trash = Object.values(res)[0];
        const trashIds = trash.trash_rids;
        if (trash.message === 'success') {
          this.toastrService.showWithAction('Deleted Successfully', 'Undo', 5000).afterDismissed().subscribe((restore) => {
            if (!restore.dismissedByAction) return;
            this.makersiteService.restoreItem(trashIds[0]).subscribe((response: any) => {
              this.toastrService.show('Restored successfully.');
              const temp = response.message.split(' ');
              this.router.navigate(['composer/metadata/', temp[1]]);
            });
          });

          this.router.navigate(['/dashboard']);
        }
      });
    });
  }

  convertNormalTextToUrl(url: string) {
    return url.trim().toLowerCase().replace(' ', '-');
  }

  /**
   *
   * @param type is Share for share dailog and Invite for invite dilog
   * @param event event is row data
   */
  shareInvite(type, selectedTabName, rid) {
    const userInfo = this.localStorageService.getItem('user_info');
    let selected;
    if (selectedTabName) {
      selected = this.convertNormalTextToUrl(selectedTabName);
    }

    const link = `/composer/${selected}/${rid}`;

    const shareData = {
      type: 'showInvite',
      value: type,
      data: {
        fr: userInfo.email,
        link,
        rid,
        usersLackingAccessList: '',
      },
    };

    this.dialog.open(InviteShareComponent, {
      data: shareData,
      panelClass: 'show-invite',
    });
  }
}
